<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
    <div v-if="searchOrFilter" class="wy-page-nodata-with-search-or-filter">
      {{$t('noDataFoundWithSearchOrFilter.message')}}
    </div>
    <div v-else class="wy-page-nodata-with-available-date-range">
      <div class="no-data-body">
        <div class="no-data-icon"></div>
        <div class="no-data-title" v-if="noDataType==1">{{$t('noDataFoundWithAvailableDateRangeType1.title')}}</div>
        <div class="no-data-title" v-if="noDataType==2">{{$t('noDataFoundWithAvailableDateRangeType2.title')}}</div>
        <div class="no-data-content">
          <div class="content-text" v-if="noDataType==1">{{$t('noDataFoundWithAvailableDateRangeType1.message')}}</div>
          <div class="content-text" v-if="noDataType==2">{{$t('noDataFoundWithAvailableDateRangeType2.message')}}</div>
        </div>
      </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
//import wyPageTooltip from '../components/widgets/wy-page-tooltip.vue'

export default Vue.extend({
  name: 'wy-page-nodata',
  props: {
    searchOrFilter: {
      type: Boolean,
      default: false
    }
  },
  components: {
    //'wy-page-tooltip': wyPageTooltip
  },

  computed: {
    ...mapGetters(['config', 'currentPageInfo', 'noDataType']),
  }
});
</script>

<style lang="scss">
.wy-page-nodata-with-search-or-filter {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 15%;
}
.wy-page-nodata-with-available-date-range {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 15%;
  height: 80%;

  .no-data-icon {
    display: block;
    border: none;
    height: 155px;
    background-position-x: 50%;
    background-repeat: no-repeat;
    background-image: url(../assets/icons/icon_no_data_new.svg);
  }
  .no-data-title {
    width: 100%;
    margin-top: 10px;
    text-align: center;
    font-size: 21px;
    color: var(--site-font-tertiary-color) !important;
    font-weight: 600;
  }
  .no-data-content {
    width: 100%;
    line-height: 22px;
    font-size: 14px;
    text-align: center;
    color: #4B5158 !important;
    
    .content-text {
      width: fit-content;
      max-width: 360px;
      font-weight: 500;
      text-align: center;
      display: -webkit-inline-box;
      display: -ms-inline-flexbox;
      display: inline-flex;
      margin-top: 20px;
    }
  }
}

</style>